import createModuleStorage from "app/pages/sales-intelligence/services/storage/factory";

const advancedSearchSessionStorageProvider = createModuleStorage(sessionStorage, "si:advanced-search");

export default advancedSearchSessionStorageProvider;
